import { gql } from '@apollo/client/core/index.js';
import { BaseApiClient } from '../base-api/index.js';
import { mergeClientOptions } from '../common/index.js';
import { IvsFragments } from './ivs-api.fragments.js';
import { makeQuery } from './ivs-api.queries.js';
import { Constants, QueryType } from './ivs-api.constants.js';
export class IVSApiService extends BaseApiClient {
    /**
     * The type of query to run
     */
    _queryType = QueryType.ALL;
    constructor(endpoint, apikey, clientOptions) {
        super(endpoint || Constants.ENDPOINT_DEV, apikey || Constants.APIKEY_DEV, mergeClientOptions(Constants.CLIENT_DEFAULT_OPTS, clientOptions));
        this.fragments = IvsFragments.allETFs;
    }
    /**
     * Set the queryType variable
     */
    set queryType(newType) {
        if (newType && Constants.QUERY_TYPES.indexOf(newType) !== -1) {
            this._queryType = newType;
        }
    }
    /**
     * Get the queryType variable content
     */
    get queryType() {
        return this._queryType;
    }
    getQuery() {
        return gql(makeQuery(this.fragments, this.queryType));
    }
    processResponse({ data, errors }) {
        if (errors) {
            console.error(Constants.LOG_ERROR_PREFIX, errors);
            this.timeOutSet = false;
            return;
        }
        this.apiSubject?.next(data);
        this.timeOutSet = false;
    }
    updateRequest(newFragments = '') {
        this.fragments = newFragments;
        if (!this.timeOutSet) {
            setTimeout(() => {
                const apiQueryObservable = this.apolloClient.watchQuery({
                    query: this.getQuery(),
                    variables: this.variables,
                });
                apiQueryObservable.subscribe(this.processResponse);
            }, this.timeOutSetting);
            this.timeOutSet = true;
        }
    }
}
//# sourceMappingURL=ivs-api.service.js.map